import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function ProductShowcase() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Fundamentos',
    desc: 'Los 7 patrones de movimiento, principios de entrenamiento, clasificación de alumnos y estructura de clase.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Banco de 150+ Ejercicios',
    desc: 'Ejecución técnica, errores comunes, regresiones y progresiones. Tren inferior, superior, core y cardio.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — 60 Clases Principiantes',
    desc: 'Clases completas con objetivo, ejercicios, tiempos, series y repeticiones. Listas para copiar y aplicar.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — 60 Clases Intermedias',
    desc: 'Circuitos, estaciones, HIIT, AMRAP, EMOM, supersets. Para alumnos que dominan los patrones.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — 60 Clases Avanzadas',
    desc: 'Alta intensidad, entrenamiento metabólico y de potencia. Las 60 clases más demandantes del kit.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Programación y Progresión',
    desc: 'Planificación semanal, mensual y trimestral. Cómo generar resultados consistentes sin estancamiento.'
  }];
  const includes = ['Planificación lista desde el día 1', 'Guion de clase completo', 'Funciona sin equipamiento costoso', 'Rúbricas y evaluación por nivel', 'Progresión semana a semana', 'Español neutro para toda LATAM', 'Adaptaciones por nivel en cada sesión', 'Formatos variados, ninguna clase igual'];
  return <section className="py-6 md:py-10 px-4 bg-brand-dark" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <div className="text-center mb-6" data-id="element-164">
          <h2 className="text-lg md:text-2xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-165">
            🏆 El sistema más completo para entrenadores funcionales
          </h2>
          <p className="text-base md:text-xl font-black text-brand-accent neon-glow mb-2" data-id="element-166">
            🏋️ KIT COMPLETO ENTRENAMIENTO FUNCIONAL LISTO
          </p>
          <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-167">
            6 tomos · 180+ clases con guion · 4 bonos · Todo listo para usar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-168">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-white/5 rounded-xl p-3 md:p-4 hover:border-brand-accent/50 transition-colors group" data-id="element-169">
              <h4 className="text-sm md:text-base font-black text-white mb-1 flex items-start group-hover:text-brand-accent transition-colors leading-tight" data-id="element-170">
                <span className="text-lg mr-2 leading-none" data-id="element-171">{tomo.icon}</span>
                <span data-id="element-172">{tomo.title}</span>
              </h4>
              <p className="text-xs text-gray-400 leading-snug font-medium ml-7" data-id="element-173">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl border border-brand-accent/30 overflow-hidden mb-6" data-id="element-174">
          <div className="bg-brand-accent py-2 px-4 text-center" data-id="element-175">
            <h4 className="text-sm md:text-base font-black text-brand-dark uppercase tracking-wide" data-id="element-176">
              Cada tomo incluye:
            </h4>
          </div>
          <div className="p-3 md:p-4" data-id="element-177">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4" data-id="element-178">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-179">
                  <CheckCircle2 className="w-4 h-4 text-brand-accent mr-2 shrink-0 mt-0.5" data-id="element-180" />
                  <span className="text-xs md:text-sm text-gray-300 font-medium leading-snug" data-id="element-181">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="bg-brand-card border border-white/10 rounded-xl p-4 text-center mb-6" data-id="element-182">
          <h3 className="text-sm md:text-base font-black text-white mb-2" data-id="element-183">
            ¿Por qué funciona en cualquier país?
          </h3>
          <p className="text-xs text-gray-400 leading-snug font-medium max-w-2xl mx-auto" data-id="element-184">
            Español neutro, sin regionalismos. Cubre los perfiles más
            frecuentes: adultos, personas que retoman ejercicio, adultos
            mayores, sobrepeso y deportistas recreativos.{' '}
            <span className="text-brand-accent font-bold" data-id="element-185">
              Creado para vos, dondequiera que estés.
            </span>
          </p>
        </div>

        <div className="w-full max-w-md mx-auto text-center" data-id="element-186">
          <Button className="text-base md:text-lg py-3 shadow-[0_0_30px_rgba(200,255,0,0.3)] w-full" data-id="element-187">
            🔥 SÍ, QUIERO DEJAR DE IMPROVISAR
          </Button>
          <p className="text-[10px] text-gray-500 mt-2 font-medium" data-id="element-188">
            Acceso inmediato • Pago seguro • Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}